export const DISPATH_SELECTED_ROWS = 'DISPATH_SELECTED_ROWS';
export const DISPATH_SELECTED_TAB = 'DISPATH_SELECTED_TAB';
export const DISPATH_TAB_TABLE_RESULTS = 'DISPATH_TAB_TABLE_RESULTS';
export const DISPATCH_APPROVED_ROWS = 'DISPATCH_APPROVED_ROWS';
export const DISPATCH_SELECTED_ACTION_ROW = 'DISPATCH_SELECTED_ACTION_ROW';
